import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { RobotoFont } from "./fonts/roboto.js";
import './App.css';

function UserList() {
  const [users, setUsers] = useState([]);
  const [filter, setFilter] = useState('aktif');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [allSelected, setAllSelected] = useState(false);

  useEffect(() => {
    fetchUsers('aktif');
  }, []);

  const fetchUsers = (userType) => {
    let apiUrl = '';
    if (userType === 'aktif') apiUrl = 'https://api.idekod.com.tr/aktif';
    else if (userType === 'bekleyen') apiUrl = 'https://api.idekod.com.tr/bekleyen';
    else if (userType === 'pasif') apiUrl = 'https://api.idekod.com.tr/pasif';

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        setUsers(Array.isArray(data) ? data : []);
        setSelectedUsers([]);
        setAllSelected(false);
      })
      .catch((error) => console.error('Error:', error));
  };

  const handleFilterChange = (e) => {
    const selectedFilter = e.target.value;
    setFilter(selectedFilter);
    fetchUsers(selectedFilter);
  };

  const handleUserSelect = (telno) => {
    if (selectedUsers.includes(telno)) {
      setSelectedUsers(selectedUsers.filter((userTelno) => userTelno !== telno));
    } else {
      setSelectedUsers([...selectedUsers, telno]);
    }
  };

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(users.map((user) => user.TELNO));
    }
    setAllSelected(!allSelected);
  };

  const handleStatusChange = (newState) => {
    fetch('https://api.idekod.com.tr/update-users', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ telnos: selectedUsers, state: newState }),
    })
      .then((response) => response.json())
      .then(() => fetchUsers(filter))
      .catch((error) => console.error('Error:', error));
  };

  const renderState = (state) => {
    const s = Number(state);
    if (s === 0) return 'Onay Bekliyor';
    if (s === 1) return 'Aktif Kullanıcı';
    if (s === 2) return 'Pasif Kullanıcı';
    return 'Bilinmiyor';
  };

  const exportToExcel = () => {
    const formattedUsers = users.map((user) => ({
      "Adı": user.RNAME,
      "Telefon": user.TELNO,
      "Durum": renderState(user.STATE),
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedUsers);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Kullanıcılar');

    const excelData = XLSX.write(workbook, { bookType: 'xlsx', type: 'array', cellStyles: true });
    const blob = new Blob([excelData], { type: 'application/octet-stream;charset=utf-8' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'Personellistesi.xlsx';
    link.click();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.addFileToVFS("Roboto-Regular.ttf", RobotoFont);
    doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
    doc.setFont("Roboto");

    const tableColumn = ["Adı", "Telefon", "Durum"];
    const tableRows = users.map((user) => [user.RNAME, user.TELNO, renderState(user.STATE)]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("Personellistesi.pdf");
  };

  return (
    <div className="page">
      <div className="page__head">
        <div>
          <h1 className="page__title">Personel Takip</h1>
          <p className="page__subtitle">Kullanıcı durumlarını görüntüleyin ve dışa aktarın</p>
        </div>
      </div>

      <div className="card">
        <div className="card__header card__header--row">
          <h2 className="card__title">Kullanıcı Listesi</h2>
          <div className="card__toolbar">
            <select
              onChange={handleFilterChange}
              value={filter}
              className="form-control"
              style={{ minWidth: 180 }}
            >
              <option value="aktif">Aktif Kullanıcılar</option>
              <option value="bekleyen">Bekleyen Kullanıcılar</option>
              <option value="pasif">Pasif Kullanıcılar</option>
            </select>
            <button onClick={exportToExcel} className="btn btn--ghost btn--sm">Excel'e Aktar</button>
            <button onClick={exportToPDF} className="btn btn--ghost btn--sm">PDF'e Aktar</button>
          </div>
        </div>

        {filter === 'bekleyen' && (
          <div className="card__body card__body--compact" style={{ borderBottom: '1px solid var(--color-border)' }}>
            <div className="btn-group">
              <button className="btn btn--success btn--sm" onClick={() => handleStatusChange(1)}>
                Seçilenleri Aktif Et
              </button>
              <button className="btn btn--danger btn--sm" onClick={() => handleStatusChange(3)}>
                Seçilenleri İptal Et
              </button>
              <button
                className={`btn btn--sm ${allSelected ? 'btn--warning' : 'btn--info'}`}
                onClick={handleSelectAll}
              >
                {allSelected ? 'Tümünü Seçme' : 'Tümünü Seç'}
              </button>
            </div>
          </div>
        )}

        <div className="table-wrapper">
          <table className="data-table data-table--striped">
            <thead>
              <tr>
                <th>Adı</th>
                <th>Telefon</th>
                <th>Durum</th>
                <th>Bölümü</th>
                {filter === 'bekleyen' && <th>Seç</th>}
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.TELNO}>
                  <td data-label="Adı">{user.RNAME}</td>
                  <td data-label="Telefon">{user.TELNO}</td>
                  <td data-label="Durum">{renderState(user.STATE)}</td>
                  <td data-label="Bölümü">{user.kurumad}</td>
                  {filter === 'bekleyen' && (
                    <td data-label="Seç">
                      <input
                        type="checkbox"
                        checked={selectedUsers.includes(user.TELNO)}
                        onChange={() => handleUserSelect(user.TELNO)}
                        aria-label={`${user.RNAME} seç`}
                      />
                    </td>
                  )}
                </tr>
              ))}
              {users.length === 0 && (
                <tr className="empty-row">
                  <td colSpan={filter === 'bekleyen' ? 5 : 4}>Kayıt bulunamadı.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default UserList;
